import List from './component.vue';
import Sort from './sort';

export * from  './types';

export {
  Sort,
  List,
};

export default List;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/index.ts